import './ModelView.scss';

export { default } from './ModelView';
